import i18n from './../../shared/i18n';

import BaseModel from "../../core/components/input-widget/BaseModel";
import {Formatter} from "@/core/services/formatter.service";

export default class ReceiptItemLocationModel extends BaseModel {
  uuid = null;
  receipt_uuid = null;
  item_location_uuid = null;
  container_type = null;
  container_count = null;
  note = null;
  is_primary = false;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  rules = {
    item_location_uuid: 'required',
    container_count: 'min_value:1|integer',
    container_type: 'max:255'
  };

  attributeHints = {
  };

  attributeLabels = {
    uuid: i18n.t('UUID'),
    receipt_uuid: i18n.t('Receipt'),
    item_location_uuid: i18n.t('Item Location'),
    item_location: i18n.t('Item Location'),
    note: i18n.t('Note'),
    container_type: i18n.t('Container Type'),
    container_count: i18n.t('Container Count'),
    enable_multiple_locations: i18n.t('Enable Multiple Locations'),
  };

  attributeTitleHint = {
    is_primary: i18n.t('A consignment can have only one primary location, which all added inventory items will inherit by default, unless changed manually.')
  }
}
